import { t } from "ttag";

import { ConfettiMinimalisticIcon, FullscreenAlert } from "@/shared/ui";

interface SuccessAlertProps {
  open: boolean;
  onContinue: VoidFunction;
}

export const SuccessAlert = ({ open, onContinue }: SuccessAlertProps) => (
  <FullscreenAlert.Root open={open}>
    <FullscreenAlert.Content>
      <FullscreenAlert.Header icon={ConfettiMinimalisticIcon}>
        <FullscreenAlert.Title>
          {t`LevelsRx is a great fit for you!`}
        </FullscreenAlert.Title>

        <div className="flex flex-col gap-2">
          <FullscreenAlert.Description>
            {t`The final step is to complete the intake forms. Once you're done, you'll unlock the full LevelsRx experience.`}
          </FullscreenAlert.Description>
          <FullscreenAlert.Description>
            {t`We're thrilled to be part of your wellness journey.`}
          </FullscreenAlert.Description>
        </div>
      </FullscreenAlert.Header>

      <FullscreenAlert.Footer>
        <FullscreenAlert.Action variant="secondary-dark" onClick={onContinue}>
          {t`Start your journey!`}
        </FullscreenAlert.Action>
      </FullscreenAlert.Footer>
    </FullscreenAlert.Content>
  </FullscreenAlert.Root>
);
